import {Component, OnInit, OnDestroy, inject} from '@angular/core';
import {TablerIconsModule} from 'angular-tabler-icons';
import {MaterialModule} from '@app/material.module';
import {TranslateModule} from '@ngx-translate/core';
import {ItemRoomComponent, getRoomStatus, RoomStatus} from '@components/rooms/item-room/item-room.component';
import {RoomsService} from '@services/api/rooms/rooms.service';
import {ApiResponse} from '@interfaces/response';
import {Room} from '@interfaces/room';
import {CompanyFilterComponent} from '@components/company-filter/company-filter.component';
import {CompanyFilterService} from '@services/company-filter/company-filter.service';
import {UserStorageService} from '@services/local-storage/user-storage/user-storage.service';
import {Roles} from '@enums/Roles';

@Component({
  selector: 'app-rooms-list',
  imports: [TablerIconsModule, MaterialModule, TranslateModule, ItemRoomComponent, CompanyFilterComponent],
  standalone: true,
  templateUrl: './rooms-list.component.html',
  styleUrl: './rooms-list.component.scss'
})
export class RoomsListComponent implements OnInit, OnDestroy {

  private room_service: RoomsService = inject(RoomsService);
  private companyFilter = inject(CompanyFilterService);
  private userStorageService = inject(UserStorageService);
  // A remote technician sees a room only when someone is calling him in it (spec of 03/11/2026): the field technician
  // has entered and waits, or the call is going on. The others see every room of their company
  public onlyCalls = false;
  public listRooms: Room[] = [];
  // Pills above the grid: 'all' or one of the statuses shown on the cards
  public filter: 'all' | RoomStatus = 'all';
  public loaded = false;
  public readonly filters: { id: 'all' | RoomStatus, label: string }[] = [
    {id: 'all', label: 'rooms_list.filter_all'},
    {id: 'waiting', label: 'rooms_list.filter_waiting'},
    {id: 'empty', label: 'rooms_list.filter_empty'},
    {id: 'busy', label: 'rooms_list.filter_busy'},
  ];

  public connectlistRooms = [];
  private refreshIntervalId: any;

  ngOnInit() {
    this.userStorageService.getUserStorage().then(user => this.onlyCalls = user?.roles?.id === Roles.OPERATOR_BO);
    this.getRooms();
    this.refreshIntervalId = setInterval(() => this.getRooms(), 5000);
  }

  ngOnDestroy() {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
    }
  }

  private getRooms() {
    this.room_service.getRoomActivePromise().then((connect_list: any) => {
      this.connectlistRooms = connect_list;
      return this.room_service.getRoomsPromise();
    }).then((listRoom: ApiResponse<Room[]>) => {
      // this.listRooms = listRoom.data;
      this.listRooms = listRoom.data.map(itemRoom => {
        const connectedItem = this.connectlistRooms.find(item => item['connectionId'] === itemRoom.uuid);
        return {
          ...itemRoom,
          connected: !!connectedItem,
          connectionNumber: connectedItem ? connectedItem['connectionNumber'] : 0
        };
      });
      this.loaded = true;
    }).catch((error) => {
      // anche in caso di errore si mostra lo stato vuoto invece di un'area bianca
      console.error(error);
      this.loaded = true;
    });
  }

  // Rooms of the company chosen in the superadmin's "Azienda" menu (all of them for the other roles)
  get companyRooms(): Room[] {
    return this.listRooms.filter(room => this.companyFilter.matches(room.company?.id)
      && (!this.onlyCalls || getRoomStatus(room) !== 'empty'));
  }

  get filteredRooms(): Room[] {
    const rooms = this.companyRooms;
    return this.filter === 'all' ? rooms : rooms.filter(room => getRoomStatus(room) === this.filter);
  }

  countFor(filter: 'all' | RoomStatus): number {
    const rooms = this.companyRooms;
    return filter === 'all' ? rooms.length : rooms.filter(room => getRoomStatus(room) === filter).length;
  }


}
